
function SliderConfigs(args) {
    let configs = {
        investmentSize: {
            title: "Investoinnin koko",
            min: 1,
            max: 30,
            step: 0.1,
            smallScaleMin: 1,
            smallScaleMax: 30,
            smallScaleStep: 0.1,
            largeScaleMin: 1,
            largeScaleMax: 500,
            largeScaleStep: 1,
            maxlength: 5,
            unit: function(amount) {
              return "milj. €";
            },
            inputBlur: function(newVal,oldVal) {
                newVal = newVal.toString().replace(",",".");
                if(isNaN(newVal)) return oldVal;
                newVal = Number(Math.round(newVal+'e'+1)+'e-'+1);
                if(newVal > this.smallScaleMax) {
                    this.changeScale(false);
                    setTimeout(() => {
                        this.changeScaleButtonToLarge();
                    },200);
                }
                if(newVal % this.step !== 0) {
                    newVal = Math.round(newVal / this.step) * this.step;
                    return Number(Math.round(newVal+'e'+1)+'e-'+1);
                }
                return Number(Math.round(newVal+'e'+1)+'e-'+1);;
            },
            changeScaleButtonToLarge: () => {
                args.changeScaleToLarge();
            },
            changeScale: function(smallScale) {
                if(smallScale) {
                    this.min = this.smallScaleMin;
                    this.max = this.smallScaleMax;
                    this.step = this.smallScaleStep;
                } else {
                    this.min = this.largeScaleMin;
                    this.max = this.largeScaleMax;
                    this.step = this.largeScaleStep;
                }
            }
        },
        payBackTime: {
            title: "Rahoitusaika",
            min: 1,
            max: 25,
            step: 1,
            maxlength: 2,
            unit: function(amount) {
                return amount === 1 ? "vuosi" : "vuotta";
            },
            inputBlur: args.yearSliderValidation,
        },
        completionYear: {
            title: "Valmistumisvuosi",
            min: new Date().getFullYear() + 1,
            max: new Date().getFullYear() + 11,
            step: 1,
            maxlength: 4,
            unit: function(amount) {return "";},
            inputBlur: args.yearSliderValidation,
        },
    }
    return configs;
}

export default SliderConfigs;
